import * as React from 'react';
import './pageBody.module.scss';

type Props = {
  className?: string;
  styleName?: string;
};

export class PageBody extends React.Component<Props> {
  render() {
    const { children, className } = this.props;
    return (
      <div styleName="page-body" className={className}>
        {children}
      </div>
    );
  }
}
